import { AuthService } from '../auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class HomeService {


  constructor(private http: HttpClient) {}

  private baseURL = environment.baseUrl;
  private initClockedIn = [];

	init() {



		//this.getLoggedInUser();

	}



	getClockedInFolks(): Observable<any> {
		return this.http.get(this.baseURL + '/rhAPI/jobEntry/getClockedInUsers');
	}

	getInitialLogEntries(): Observable<any> {
		return this.http.get(this.baseURL + '/rhAPI/log/lasthundred');
	}




	getLoggedInUser() {

		/*
		return this.auth.getUser$().subscribe(
			res => {
			}, err => {
		});
		*/


		/*
			this.auth.getUser$().pipe(
				tap => {
				}).subscribe(
				res => {
				}, err => {
			});
		*/

	}

	getSafetyCounters(): Observable<any> {
		return this.http.get(this.baseURL + '/rhAPI/safety/counters');
	}

	resetSafetyCounter(incident_type: string, reason: string, employee_id: number): Observable<any> {
		return this.http.post(this.baseURL + '/rhAPI/safety/counters/reset', { incident_type, reason, employee_id });
	}

	adjustSafetyCounter(incident_type: string, direction: string, employee_id: number): Observable<any> {
		return this.http.post(this.baseURL + '/rhAPI/safety/counters/adjust', { incident_type, direction, employee_id });
	}

	runAxisReconcile(): Observable<any> {
		return this.http.post(this.baseURL + '/rhAPI/axis/reconcile', {});
	}

}